import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import { ComponentHelper } from "../../core/util/componentHelper.js"
import { Helper } from "../../core/util/helper.js"
import { IsSearchField } from "../../core/components/isSearchField.js";
import React from "react";

interface SearchProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: SearchState;
    settings: any;
}

export class SingleSelectSearchComponent extends React.Component<SearchProps, any>{

    private searchTypeToUrl = (searchType: "address" | "machine" | "project" | "article" | "resource" | "ticket" | null): { url: string, key: string, pkField: string, autocompleteUrl: string, autocompleteTemplate } => {

        if (!Helper.hasValue(searchType) || searchType == "address") {
            return { url: "DynamicSearch/Window/Address", key: "adrnr", pkField: "AdrNr", autocompleteUrl: "AddressLookup/Find", autocompleteTemplate: "<table cellspacing='0' style='table-layout:fixed; width:650px'><colgroup><col style='width: 100px' /><col style='width: 250px' /><col style='width: 300px' /></colgroup><tr style='background-color:# if(data.Status == 1) { #\\#cccccc# } else { #inherit# } #'><td style='vertical-align:top; word-wrap: break-word;'>${data.AdrNr}</td><td style='vertical-align:top'>${data.AdrName}</td><td style='vertical-align:top'>${data.Plz}  ${data.Ort}</td></tr></table>" };
        }
        else if (searchType == "machine") {
            return { url: "DynamicSearch/Window/Machine", key: "maschnr", pkField: "MaschNr", autocompleteUrl: "MachineLookup/Find", autocompleteTemplate: "<table cellspacing='0' style='table-layout:fixed; width:650px'><colgroup><col style='width: 100px' /><col style='width: 250px' /><col style='width: 300px' /></colgroup><tr style='background-color:# if(data.Status == 1) { #\\#cccccc# } else { #inherit# } #'><td style='vertical-align:top; word-wrap: break-word;'>${data.MaschNr}</td><td style='vertical-align:top'>${data.MaschBezeichnung}</td><td style='vertical-align:top'>${data.AdrName}</td></tr></table>" };
        }
        else if (searchType == "project") {
            return { url: "DynamicSearch/Window/Project", key: "projnr", pkField: "ProjNr", autocompleteTemplate: "<table cellspacing='0' style='table-layout:fixed; width:650px'><colgroup><col style='width: 100px' /><col style='width: 250px' /><col style='width: 300px' /></colgroup><tr style='background-color:# if(data.Status == 1) { #\\#cccccc# } else { #inherit# } #'><td style='vertical-align:top; word-wrap: break-word;'>${data.ProjNr}</td><td style='vertical-align:top'>${data.Kennwort}</td><td style='vertical-align:top'>${data.Addresse}</td></tr></table>", autocompleteUrl: "ProjectLookup/Find" };
        }
        else if (searchType == "article") {
            return { url: "DynamicSearch/Window/Article", key: "artnr", pkField: "ArtikelNummer", autocompleteTemplate: null, autocompleteUrl: null };
        }
        else if (searchType == "resource") {
            return { url: "DynamicSearch/Window/Resource", key: "ressnr", pkField: "Ressnr", autocompleteUrl: "ResourceLookup/FindWithId", autocompleteTemplate: "<table cellspacing='0' style='table-layout:fixed; width:250px'><colgroup><col style='width: 80px' /><col style='width: 100px' /><col style='width: 100px' /></colgroup><tr style='background-color:# if(data.StatusAsInt == 1) { #\\#cccccc# } else { #inherit# } #'><td style='vertical-align:top; word-wrap: break-word;'>${data.Ressnr}</td><td style='vertical-align:top'>${data.Name}</td><td style='vertical-align:top'>${data.Vorname}</td></tr></table>" };
        }
        else if (searchType == "ticket") {
            return { url: "DynamicSearch/Window/Procedure", key: "problemnr", pkField: "ProblemNr", autocompleteTemplate: null, autocompleteUrl: null };
        }
    };

    constructor(props, context) {
        super(props, context);
        this.state = {};
    }

    handleOnSelect = (data) => {
        this.props.onTextChange(this.props.settings.name, data);
        this.setState({ showSearch: false });
    }

    handleFieldClicked = (field: { model: string }, value: any, dataItem?: any[]) => {
        this.props.onTextChange(this.props.settings.name, value);
    }

    render() {
        const componentHelper = ComponentHelper.createFactory();
        const componentSearchProps = componentHelper.getDefaultSearchFieldProps();
        componentSearchProps.multiSelectMode = false;
        const params = this.searchTypeToUrl(this.props.settings.searchType);
        componentSearchProps.field.searchWindowUrl = params.url;

        if (params.autocompleteUrl) {
            componentSearchProps.field.autocompleteUrl = params.autocompleteUrl;
            componentSearchProps.field.autocompleteTemplate = params.autocompleteTemplate;
            componentSearchProps.field.autocompleteEnabled = true;
            componentSearchProps.field.searchValueField = params.pkField;
            componentSearchProps.field.searchTextField = params.pkField;
            componentSearchProps.field.dataTextField = params.pkField;
            componentSearchProps.field.dataValueField = params.pkField;
            componentSearchProps.field.autocompleteDataTextField = params.pkField;
        }
        const values = this.props.values[this.props.settings.name];
        return (
            <div>
                <react_components.ReactColumn width={this.props.metadataSettings.width}>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        <react_components.TruncatedLabel>{this.props.settings.label}</react_components.TruncatedLabel>
                        <div>
                            <IsSearchField key={params.key}
                                {...componentSearchProps}
                                value={values}                                
                                onChange={(q, newValue, selectedItem) => {
                                    this.handleFieldClicked(q, newValue);
                                }}

                                onClose={() => {

                                }}
                                preventButtonFocus={true}
                            />
                        </div>
                    </div>
                </react_components.ReactColumn>
            </div>
        )
    }
};

export class SearchState extends propertyTypes.BaseComponentProps {
    private labelMetadata = new propertyTypes.TranslatableTextProperty("label", "Label");
    public label: string;

    private searchTypeMetadata = new propertyTypes.SelectProperty("searchType", "Search type")
        .addOption("address", "Address search")
        .addOption("resource", "Resource search")
        .addOption("machine", "Machine search")
        .addOption("project", "Project search")
        .addOption("ticket", "Ticket search");
    private searchType: string;

    private multiselectMetadata = new propertyTypes.CheckBoxProperty("multiselect", "Multi select");
    private multiselect: string;

    private searchMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        this.getNameMetadata().SetMandatory(true);
        const baseMetaData = super.getMetadata();
        this.searchMetadataAll = baseMetaData.concat([this.labelMetadata, this.searchTypeMetadata, this.multiselectMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.searchMetadataAll;
    }
}